module.exports = __webpack_public_path__ + "src/assets/img/door_right.8c10a179.svg";